import { NoDataFoundError } from '../APIRequestError';
import { handleSentryErrors } from '../HandleSentryErrors';
import { putRequest as put } from '../HttpMethods';

interface UpdateEntityParams<T> {
  path: string;
  entity: T;
  isEntity?: (obj: any) => obj is T;
  functionName: string;
}

export const updateEntity = async <T>({
  path,
  entity,
  functionName,
}: UpdateEntityParams<T>): Promise<T | null> => {
  const parsedData = await put<T>('QBilling', path, entity);
  if (!parsedData || !Object.keys(parsedData).length) {
    const error = new NoDataFoundError('No Data Found', functionName, path);
    handleSentryErrors({
      error: error,
      displayNotification: false,
      functionName: functionName,
      params: path,
    });
  }

  return parsedData as T;
};
